import { useContext } from 'react';
import { TrialContext } from 'providers/Trial';

const useTrial = () => useContext(TrialContext);

export default useTrial;
